<app-leveltwo [pageName]="'Contest your Assessed Value (Assessment appeals)'">
  <div class="General">

      <h3>{{'ContestAssessment.PageTitle'|translate}}</h3>

      <h4>{{'ContestAssessment.Therearetwo'|translate}}</h4>


      <h5>{{'ContestAssessment.WiththeAssessor'|translate}}</h5>
      <ul>
        <li>{{'ContestAssessment.WiththeAssessor1'|translate}}<br><br></li>
        <li>{{'ContestAssessment.WiththeAssessor2'|translate}}</li>
      </ul>

      <h5>{{'ContestAssessment.WiththeBoard'|translate}}</h5>
      <ul>
        <li>{{'ContestAssessment.WiththeBoard1'|translate}}</li>
      </ul>

      <h4>{{'ContestAssessment.Decline'|translate}}</h4>

      <p>{{'ContestAssessment.ifyou'|translate}}</p>

      <p [innerHTML]="'DeclineinValue.DIVOpenAnnualv2'|translate"></p><!--<b>{{'ContestAssessment.Applicationswill2022'|translate}}</b>-->
      <p [innerHTML]="'DeclineinValue.DIVNote'|translate"></p>
      <a class="btn btn-primary mb-4" routerLink="/tax-relief/decline-in-value/">
        <span>{{'ContactAssessor.Forms'|translate}}</span>
      </a>

      <p>{{'ContestAssessment.CaliforniaProp13'|translate}}</p>

      <p>{{'ContestAssessment.in1978'|translate}}<b>{{'ContestAssessment.Currentmarket'|translate}}</b></p>
      <p>{{'ContestAssessment.TheOffice2'|translate}}</p>
      <!--
      <a class="btn btn-primary" href="https://www.boe.ca.gov/info/assessmentvideo/" target="_blank">
        <span>{{'ContestAssessment.Aboutthisprocess'|translate}}</span>
      </a>

      <br>
      <br>-->

      <h4>{{'ContestAssessment.AppealinganAssessment'|translate}}</h4>
      <p>{{'ContestAssessment.toappeal1'|translate}} <a href="https://bos.lacounty.gov/" target="_blank">{{'ContestAssessment.assessmentappeals'|translate}}</a>. {{'ContestAssessment.toappeal2'|translate}}</p>
      <ol>
        <li>{{'ContestAssessment.mailingdate1'|translate}}</li>
        <li>{{'ContestAssessment.mailingdate2'|translate}}</li>
        <li>{{'ContestAssessment.postmarkdate'|translate}}</li>
      </ol>
      <p>{{'ContestAssessment.regularroll'|translate}}</p>
      <p [innerHTML]="'ContestAssessment.Appealsmustbe'|translate"></p>


      <a class="btn btn-primary" href="http://bos.lacounty.gov/Services/Assessment-Appeals/" target="_blank">
        <span>{{'ContestAssessment.assessmentappeals'|translate}}</span>
      </a>



  </div>
</app-leveltwo>
